import { yupResolver } from '@hookform/resolvers/yup';
import TextField from '@mui/material/TextField';
import { Controller, useForm } from 'react-hook-form';
import { useCompanyCore } from '../../../../core/modules/company';
import { useCallback, useEffect, useState } from 'react';
import * as yup from 'yup';
import { Avatar, Button } from '@mui/material';
import { isEmpty } from 'lodash';
import Spinner from '../../Spinner';
import { useTranslation } from 'react-i18next';
import { PhotoCamera } from '@mui/icons-material';
interface FormData {
  name: string;
  rut: string;
}

const schema = yup.object().shape({
  name: yup.string().required('You must enter a name'),
  rut: yup.string().required('You must enter a rut'),
});

const defaultValues: FormData = {
  name: '',
  rut: '',
};

const BasicInfoTab = () => {
  const { t } = useTranslation();
  const { company, putCompany, getCompany } = useCompanyCore();

  const [loading, setLoading]  = useState(false);
  const [selectedAvatar, setSelectedAvatar] = useState<File | null>(null);
  const [previewAvatarUrl, setPreviewAvatarUrl] = useState<string | null>(null);

  const { control, formState, handleSubmit, setValue } = useForm({
    mode: 'onChange',
    defaultValues,
    resolver: yupResolver(schema),
  });
  const { errors } = formState;

  useEffect(() => {
    if (company) {
      setValue('name', company.name);
      setValue('rut', company.rut);
    }
  }, [company, setValue]);

  const onSubmit = useCallback(
    ({ name, rut }: FormData) => {
      setLoading(true);
      putCompany(
        company?.id!,
        {
          name, rut, selectedAvatar
        },
        () => {
          getCompany(company?.id!, () => {
            setLoading(false);
          });
        },
        () => {
          setLoading(false);
        }
      );
    },
    [putCompany, company?.id, selectedAvatar, getCompany]
  );

  useEffect(() => {
    return () => {
      if (previewAvatarUrl) {
        URL.revokeObjectURL(previewAvatarUrl);
      }
    };
  }, [previewAvatarUrl]);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      setSelectedAvatar(file);
      const newPreviewUrl = URL.createObjectURL(file);

      if (previewAvatarUrl) {
        URL.revokeObjectURL(previewAvatarUrl);
      }
      setPreviewAvatarUrl(newPreviewUrl);
    }
  };

  return (
    <>
      <div className="flex flex-col justify-center items-center mb-32">
        <Avatar
          alt="company photo"
          src={previewAvatarUrl || company?.selectedAvatar}
          sx={{ width: 100, height: 100 }}
        >
          {company?.name[0]}
        </Avatar>
        <input
          accept="image/jpeg"
          style={{ display: 'none' }}
          id="avatar-upload"
          type="file"
          onChange={handleFileChange}
        />
        <label htmlFor="avatar-upload">
          <Button color="primary" aria-label="upload picture" component="span" className="mt-2">
            <PhotoCamera />
            Elegir Avatar
          </Button>
        </label>
      </div>
      <form name="courseForm" noValidate onSubmit={handleSubmit(onSubmit)}>
        <div className="flex items-center w-full">
          <div className="ms-10 flex-1">
            <div className="flex">
              <Controller
                control={control}
                name="name"
                render={({ field }) => (
                  <TextField
                    {...field}
                    className="mb-32 mr-4"
                    label={t('label.name')}
                    id="name"
                    error={!!errors.name}
                    helperText={errors?.name?.message}
                    variant="outlined"
                    disabled={loading}
                    required
                    fullWidth
                  />
                )}
              />

              <Controller
                control={control}
                name="rut"
                render={({ field }) => (
                  <TextField
                    {...field}
                    className="mb-32"
                    label="RUT"
                    id="rut"
                    error={!!errors.rut}
                    helperText={errors?.rut?.message}
                    variant="outlined"
                    disabled={loading}
                    required
                    fullWidth
                  />
                )}
              />
            </div>
          </div>
        </div>

        <div className="flex justify-end mt-32">
          <Button
            variant="contained"
            color="secondary"
            sx={{ borderRadius: 50 }}
            disabled={!isEmpty(errors) || loading}
            type="submit"
          >
            <Spinner show={loading} />
            {t('button.save')}
          </Button>
        </div>
      </form>
    </>
  );
};

export default BasicInfoTab;
